import { useState } from 'react';
import { toast } from 'react-toastify';

interface UseSaveLaterArgs {
  saveAsDraft: () => Promise<void>;
  onSaveLater: () => void;
}

const useSaveLaterHandler = ({ saveAsDraft, onSaveLater }: UseSaveLaterArgs) => {
  const [saving, setSaving] = useState(false);

  const handleSaveLater = async () => {
    if (saving) return;
    setSaving(true);
    try {
      await saveAsDraft();
      toast.success('Progress saved.');
      onSaveLater();
    } catch (err: any) {
      console.error(err);
      toast.error(err?.response?.data?.message || 'Could not save progress.');
    } finally {
      setSaving(false);
    }
  };

  return { saving, handleSaveLater };
};

export default useSaveLaterHandler;
